import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  GridLayout,
  GridLayoutItem,
  TabStrip,
  TabStripSelectEventArguments,
  TabStripTab,
} from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import TaskDialog from "./TaskDialog";
import { getAllTasks } from "./services/services.tasks";
import { getAllUser } from "../../clientForm/services/services.clientform";
import { setSelectedTab } from "./taskSlice";
const TaskActivityTab: React.FC = () => {
  const location = useLocation();
  const SelectedTab = useAppSelector((state) => state?.tasks?.SelectedTab);
  const dispatch = useAppDispatch();
  const handleSelect = (e: TabStripSelectEventArguments) => {
    dispatch(setSelectedTab(e.selected));
  };
  const LeadID = location?.state?.ActivityLog?.LeadID;
  const NBInquiryTypeID = location?.state?.ActivityLog?.NBInquiryTypeID;
  const NBLeadTypeID = location.state?.ActivityLog?.NBLeadTypeID;

  useEffect(() => {
    dispatch(getAllUser());
  }, []);
  useEffect(() => {
    const payload = {
      LeadID: LeadID ?? null,
      NBInquiryTypeID: NBInquiryTypeID ?? null,
      NBLeadTypeID: NBLeadTypeID ?? null,
      TaskStatus: SelectedTab === 0 ? "" : "Completed",
    };
    dispatch(getAllTasks(payload));
  }, [SelectedTab]);

  return (
    <>
      <GridLayoutItem
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          //   padding: "4px 20px 20px 0",
        }}
      >
        {/* <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          Lead Activity Logs
        </Typography.h4> */}
      </GridLayoutItem>
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem>
          <TabStrip
            className="nb-inquiry-types-tab"
            selected={SelectedTab}
            onSelect={handleSelect}
          >
            <TabStripTab title={"Tasks"}>
              <TaskDialog />
            </TabStripTab>
            <TabStripTab title={"Closed Tasks"}>
              <TaskDialog />
            </TabStripTab>
          </TabStrip>
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default TaskActivityTab;
